import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "components/ui/carousel";
import { useEffect, useState } from "react";
import PhotoPostContent from "../photo-post-content/PhotoPostContent";
import { Ellipsis, ZoomInIcon, ZoomOutIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import PostOption from "../post-option/PostOption";
import { AppLog } from "services";
import NewFeedDailogBlock from "../new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBlock";
import NewFeedDailogDeletePost from "../new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogDeletePost";
import NewFeedDialogReportPost from "../new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogReportPost";

export default function AlbumPostContent({ post }: { post: any }) {
  const [count, setCount] = useState(0);
  const [current, setCurrent] = useState(0);
  const [api, setApi] = useState<CarouselApi>();
  const [scale, setScale] = useState(1);
  const maxZoom = 1.8;
  const minZoom = 1;

  const handleZoomIn = (event: React.MouseEvent<SVGElement>) => {
    event.preventDefault();
    if (scale < maxZoom) {
      setScale((prev) => Math.min(prev + 0.1, maxZoom)); // Increment zoom
    }
  };

  const handleZoomOut = (event: React.MouseEvent<SVGElement>) => {
    event.preventDefault();
    if (scale > minZoom) {
      setScale((prev) => Math.max(prev - 0.1, minZoom)); // Decrement zoom
    }
  };

  const handleOnChange = (index: number) => {
    setCurrent(index + 1);
  };

  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(post?.post_attachments.length);
  }, [api, post]);
  const [postOption, setPostOption] = useState<{
    isOpen: boolean;
    buttonRef: HTMLButtonElement | null;
    post: any;
  }>({
    isOpen: false,
    buttonRef: null,
    post: null,
  });

  // Popover Option

  const onClosePostOption = () => {
    setPostOption({
      isOpen: false,
      buttonRef: null,
      post: null,
    });
  };
  const onOpenPostOption = (e: React.MouseEvent<HTMLButtonElement>, post: any) => {
    setPostOption({
      isOpen: true,
      buttonRef: e.currentTarget,
      post: post,
    });
  };
  // ------------------State and function Dailog---------------------
  const [dialogBlock, setDialogBlock] = useState({
    isOpen: false,
    post: null,
    label: null,
  });
  const onOpenDialogBlock = (post: any, label: any) => {
    try {
      setDialogBlock({
        isOpen: true,
        post: post,
        label: label,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };
  const [dialogDeletePost, setDialogDeletePost] = useState({
    isOpen: false,
    post: null,
    label: null,
  });

  const onOpenDialogDeletePost = (post: any, label: any) => {
    try {
      setDialogDeletePost({
        isOpen: true,
        post: post,
        label: label,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };
  const [dialogReportPost, setDialogReportPost] = useState({
    isOpen: false,
    post: null,
    label: null,
  });
  const onOpenDialogReportPost = (post: any, label: any) => {
    try {
      setDialogReportPost({
        isOpen: true,
        post: post,
        label: label,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };
  return (
    <>
      <Carousel setApi={setApi} onSlideChange={handleOnChange}>
        <CarouselContent>
          {post?.post_attachments.map((item: any, index: number) => {
            return (
              <CarouselItem className="flex justify-center items-center" key={index}>
                <div
                  key={item?.id}
                  style={{
                    aspectRatio: `${item?.attachment_media_width ?? 16} / ${item?.attachment_media_height ?? 9}`,
                  }}
                >
                  <div className="flex justify-center items-center  ">
                    <PhotoPostContent post={item} isAlbum={true} scaleAlbum={scale} />
                  </div>
                </div>
              </CarouselItem>
            );
          })}
        </CarouselContent>
      </Carousel>

      <div className="absolute max-sm:top-3 max-sm:right-3 top-5 right-8 flex space-x-2 z-50 select-none">
        <div className={`font-semibold text-xs bg-gray-600 text-white opacity-70 max-sm:p-1 p-2    rounded-full `}>
          {current}/{count}
        </div>
        <ZoomInIcon
          onClick={handleZoomIn}
          className={`w-8 h-8 max-sm:w-6 max-sm:h-6 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200 cursor-pointer ${
            scale >= maxZoom ? "opacity-50 cursor-not-allowed" : "hover:opacity-100"
          }`}
        />
        <ZoomOutIcon
          onClick={handleZoomOut}
          className={`w-8 h-8 max-sm:w-6 max-sm:h-6 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200 cursor-pointer ${
            scale <= minZoom ? "opacity-50 cursor-not-allowed" : "hover:opacity-100"
          }`}
        />
        {/* <Ellipsis
          onClick={(e: any) => onOpenPostOption(e, post)}
          className="w-8 h-8 max-sm:w-6 cursor-pointer max-sm:h-6 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200"
        /> */}
      </div>
      {/* -------------------- */}
      {/* {postOption.isOpen && (
        <PostOption
          isOpen={postOption.isOpen}
          onOpenChange={(_) => onClosePostOption()}
          post={postOption.post}
          buttonRef={postOption.buttonRef}
          onClickShare={({ post, label }) => {
            console.log("post", post);
            console.log("label", label);
            if (label === "Share Post") {
              // onOpenDialogShare("");
            } else if (label === "Block User") {
              onOpenDialogBlock(post, label);
            } else if (label === "Boring User") {
              onOpenDialogBlock(post, label);
            } else if (label === "Delete Post") {
              onOpenDialogDeletePost(post, label);
            } else if (label === "Report Post") {
              onOpenDialogReportPost(post, label);
            }
          }}
        />
      )}
      {dialogBlock.isOpen && (
        <NewFeedDailogBlock
          post={dialogBlock?.post}
          label={dialogBlock?.label}
          isDialogOpen={dialogBlock.isOpen}
          setIsDialogOpen={(isOpen) =>
            setDialogBlock({ ...dialogBlock, isOpen })
          }
        />
      )}

      {dialogDeletePost.isOpen && (
        <NewFeedDailogDeletePost
          post={dialogDeletePost?.post}
          label={dialogDeletePost?.label}
          isDialogOpen={dialogDeletePost.isOpen}
          setIsDialogOpen={(isOpen) =>
            setDialogDeletePost({ ...dialogDeletePost, isOpen })
          }
        />
      )}

      {dialogReportPost.isOpen && (
        <NewFeedDialogReportPost
          post={dialogReportPost?.post}
          label={dialogReportPost?.label}
          isDialogOpen={dialogReportPost.isOpen}
          setIsDialogOpen={(isOpen) =>
            setDialogReportPost({ ...dialogReportPost, isOpen })
          }
        />
      )}

      {postOption.isOpen && (
        <PostOption
          isOpen={postOption.isOpen}
          onOpenChange={(_) => onClosePostOption()}
          post={postOption.post}
          buttonRef={postOption.buttonRef}
          onClickShare={({ post, label }) => {
            console.log("post", post);
            console.log("label", label);
            if (label === "Share Post") {
            } else if (label === "Block User") {
              onOpenDialogBlock(post, label);
            } else if (label === "Boring User") {
              onOpenDialogBlock(post, label);
            } else if (label === "Delete Post") {
              onOpenDialogDeletePost(post, label);
            } else if (label === "Report Post") {
              onOpenDialogReportPost(post, label);
            }
          }}
        />
      )} */}
    </>
  );
}
